import tw from "tailwind-styled-components";
import { BoxHead, Underline } from "../../Styles/PageStyles";
import { ownership_roles } from "../../../Config";
import LandlordLeaseTable from "./LandlordLeaseTable";
import { useState } from "react";
import SideModal from "../../SideModal";
import LandlordLeaseViewModal from "./LandlordLeaseViewModal";
import NotFoundModel from "../../NotFoundModel";

export default function LeaseDetails({
    landlordData,
    leaseDetails,
    setSelectedData,
    setViewDetails
}) {

    const formatDate = (date) => {
        if (!date) return "-";
        try {
            return new Date(date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        } catch {
            return "-";
        }
    };

    const formatCurrency = (val) => {
        if (!val && val !== 0) return "-";
        return `₹${Number(val).toLocaleString("en-IN")}`;
    };
    const getRentCollectionTypeText = (collectionType) => {
        switch (collectionType) {
            case 1: return "Advance Rent";
            case 2: return "Month-End Rent";
            default: return "--";
        }
    };

    return (
        <Wrapper>
            <BoxHead>
                <Title className="!mb-0">
                    Landlord & Lease Details
                    <Underline />
                </Title>
            </BoxHead>
            {!leaseDetails &&
                <NotFoundModel msg={"No landlord attached to this property"} />}
            {/* MAIN GRID */}
            {leaseDetails &&
                (
                    Array.isArray(leaseDetails)
                        ? leaseDetails.length > 0
                        : Object.keys(leaseDetails).length > 0
                ) && (
                    Array.isArray(leaseDetails) ? (
                        <TableWrapper>
                            <LandlordLeaseTable leaseDetails={leaseDetails}
                                setViewDetails={setViewDetails}
                                setSelectedData={setSelectedData} />
                        </TableWrapper>
                    ) : (
                        <Grid>
                            {/* ---------------- LANDLORD INFO ---------------- */}
                            <Card>
                                <SectionTitle>Landlord Information</SectionTitle>

                                <Row>
                                    <Label>Name</Label>
                                    <Value>{leaseDetails?.landlordName || "-"}</Value>
                                </Row>

                                <Row>
                                    <Label>Mobile</Label>
                                    <Value>{leaseDetails?.landlordMobile || "-"}</Value>
                                </Row>

                                <Row>
                                    <Label>Alt Mobile</Label>
                                    <Value>{leaseDetails?.landlordAltMobile || "-"}</Value>
                                </Row>
                                <Row>
                                    <Label>Ownership</Label>
                                    <Value>
                                        {ownership_roles.find(r => r.value === leaseDetails?.ownershipType)?.label || "-"}
                                    </Value>

                                </Row>
                                <Row>
                                    <Label>Email</Label>
                                    <Value>{leaseDetails?.landlordEmail || "-"}</Value>
                                </Row>

                                <Divider />

                                <SectionTitle>Landlord Rent Summary</SectionTitle>

                                <Row>
                                    <Label>Current Month Paid</Label>
                                    <Value>{formatCurrency(landlordData?.curMonthRentPaid)}</Value>
                                </Row>

                                <Row>
                                    <Label>Pending Rent</Label>
                                    <Pending>
                                        {formatCurrency(landlordData?.rentPending)}
                                    </Pending>
                                </Row>

                                <Row>
                                    <Label>Total Rent To Be Paid</Label>
                                    <Highlight>
                                        {formatCurrency(landlordData?.totalRentToBePaid)}
                                    </Highlight>
                                </Row>
                            </Card>
                            {/* ---------------- LEASE DETAILS ---------------- */}
                            <Card>
                                <SectionTitle>Lease Information</SectionTitle>

                                {/* <Row>
                        <Label>Property Name</Label>
                        <Value>{leaseDetails?.propertyName || "-"}</Value>
                    </Row>

                    <Row>
                        <Label>Address</Label>
                        <Value>{leaseDetails?.propertyAddress || "-"}</Value>
                    </Row> */}
                                <Row>
                                    <Label>Rent</Label>
                                    <Highlight>{formatCurrency(leaseDetails?.rent)}</Highlight>
                                </Row>
                                <Row>
                                    <Label>Collection Type</Label>
                                    <Highlight> {getRentCollectionTypeText(leaseDetails.rentCollectionType)}
                                    </Highlight>
                                </Row>

                                <Row>
                                    <Label>Security Deposit</Label>
                                    <Value>{formatCurrency(leaseDetails?.security)}</Value>
                                </Row>
                                <Row>
                                    <Label>Lease Period</Label>
                                    <Value>
                                        {formatDate(leaseDetails?.startDate)} —{" "}
                                        {formatDate(leaseDetails?.endDate)}
                                    </Value>
                                </Row>

                                <Row>
                                    <Label>Lock-in Period</Label>
                                    <Value>{leaseDetails?.lockInPeriod} Months</Value>
                                </Row>

                                <Row>
                                    <Label>Notice Period</Label>
                                    <Value>{leaseDetails?.notice} Months</Value>
                                </Row>

                                <Row>
                                    <Label>Rent Date</Label>
                                    <Value>{formatDate(leaseDetails?.rentDate)}</Value>
                                </Row>
                                <Row>
                                    <Label>Increment</Label>
                                    <Highlight> {leaseDetails.incrementType === 2 ? leaseDetails.incrementValue + '%' : leaseDetails.incrementType === 1 ? '₹' + leaseDetails.incrementValue : "-"}
                                    </Highlight>
                                </Row>
                                <Row>
                                    <Label>Increment Month</Label>
                                    <Highlight> {leaseDetails.incrementMonth
                                        ? `${leaseDetails.incrementMonth} month${leaseDetails.incrementMonth > 1 ? "s" : ""
                                        }`
                                        : "--"}
                                    </Highlight>

                                </Row>
                            </Card>
                        </Grid>))}
        </Wrapper>
    );
}

/* ---------------- STYLES ---------------- */

const Wrapper = tw.div`px-4 mt-2 space-y-4`;
const TableWrapper = tw.div`border bg-white rounded-md`;
const Grid = tw.div`
grid grid-cols-1 lg:grid-cols-2 gap-6
`;

const Card = tw.div`
bg-white border border-gray-200 rounded-xl p-5 shadow-sm
`;

const Row = tw.div`
flex justify-between items-start py-2 border-b border-gray-100 last:border-none
`;

const Label = tw.span`
text-sm text-gray-500
`;

const Value = tw.span`
text-sm text-gray-800 font-medium text-right
`;

const Highlight = tw.span`
text-base font-semibold text-primary-color text-right
`;

const Pending = tw.span`
text-sm font-semibold text-red-500 text-right
`;

const SectionTitle = tw.h3`
text-sm font-semibold text-gray-700 mb-3
`;

const Divider = tw.div`my-4 border-t border-gray-200`;

const Title = tw.h2`
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;
